// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__J3TmW","type":"styles_type__5SRJi","choices":"styles_choices__2XEzo"};